import { ValidationStrategy } from "./validation.strategy";

export class CollectionValidationStrategy extends ValidationStrategy {

    public validate(): boolean {
        if(!this.isRequired) {
            return true
        }

        let isValid = this.attribute.value != null &&
                      this.attribute.value.length > 0

        if(!isValid) {
            this.attribute.hasError = true
            return false
        }

        return true
    }
}